<template>
  <div class="brand-emblem" :class="{ 'brand-emblem--fill-white': fillWhite }">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="none"
      viewBox="0 0 245.5 70.8"
      xml:space="preserve"
    >
      <polygon class="brand-emblem-0" points="33.6,30.7 0,67.2 0,11.5 " />
      <polygon class="brand-emblem-1" points="46.7,0 33.6,30.7 35.1,0 " />
      <polygon class="brand-emblem-2" points="101.9,0 33.6,30.7 46.7,0 " />
      <line class="brand-emblem-3" x1="46.7" y1="0" x2="33.6" y2="30.7" />
      <polygon class="brand-emblem-4" points="35.1,0 33.6,30.7 25,0 " />
      <line class="brand-emblem-5" x1="33.6" y1="30.7" x2="0" y2="11.5" />
      <polygon class="brand-emblem-6" points="33.6,30.7 0,11.5 0,0 25,0 " />
      <polygon class="brand-emblem-7" points="245.5,0 245.5,70.8 58.6,70.8 56.9,68 33.6,30.7 101.9,0 " />
      <polygon class="brand-emblem-8" points="58.6,70.8 30.7,70.8 33.6,30.7 56.9,68 " />
      <polyline class="brand-emblem-9" points="58.6,70.8 56.9,68 33.6,30.7 " />
      <polygon class="brand-emblem-10" points="33.6,30.7 30.7,70.8 0,70.8 0,67.2 " />
      <polygon class="brand-emblem-0" points="206.7,0 245.5,0 245.5,70.8 191,70.8 163.9,41.4 " />
      <polygon class="brand-emblem-1" points="163.9,41.4 160.8,70.8 150.6,70.8 " />
      <polygon class="brand-emblem-2" points="163.9,41.4 150.6,70.8 45.6,70.8 56.9,68 " />
      <line class="brand-emblem-3" x1="163.9" y1="41.4" x2="150.6" y2="70.8" />
      <polygon class="brand-emblem-4" points="168.2,70.8 160.8,70.8 163.9,41.4 " />
      <line class="brand-emblem-5" x1="191" y1="70.8" x2="163.9" y2="41.4" />
      <polygon class="brand-emblem-6" points="191,70.8 168.2,70.8 163.9,41.4 " />
      <polygon class="brand-emblem-8" points="169.3,0 163.9,41.4 116.6,0 " />
      <line class="brand-emblem-9" x1="163.9" y1="41.4" x2="148.7" y2="0" />
      <polygon class="brand-emblem-10" points="169.3,0 206.7,0 163.9,41.4 " />
    </svg>
  </div>
</template>

<script>
// export
export default {
  // name
  name: 'Brand',
  // props
  props: {
    fillWhite: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.brand-emblem svg {
  width: 100%;
  height: 100%;
}

.brand-emblem-0 {
  fill: #960048;
}
.brand-emblem-1 {
  fill: #009877;
}
.brand-emblem-2 {
  fill: #00c4b3;
}
.brand-emblem-3 {
  fill: none;
  stroke: #4ab9b3;
  stroke-width: 0;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.brand-emblem-4 {
  fill: #006580;
}
.brand-emblem-5 {
  fill: none;
  stroke: #50163f;
  stroke-width: 0;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.brand-emblem-6 {
  fill: #602651;
}
.brand-emblem-7 {
  fill: #ffa400;
}
.brand-emblem-8 {
  fill: #ff5c35;
}
.brand-emblem-9 {
  fill: none;
  stroke: #ea5740;
  stroke-width: 0;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.brand-emblem-10 {
  fill: #b32572;
}

.brand-emblem--fill-white svg * {
  stroke: white !important;
}
</style>
